/**
 * @GENERATED from Figma node 3608:51037
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const SegmentDark = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#52BD94"
      d="M2 3.667C2 2.747 2.746 2 3.667 2h16.666C21.253 2 22 2.746 22 3.667v16.666c0 .92-.746 1.667-1.667 1.667H3.667C2.747 22 2 21.254 2 20.333z"
    />
    <path
      fill="#fff"
      d="M18.642 9.517h-7.997a.27.27 0 0 0-.276.264v.892a.27.27 0 0 0 .276.263h7.997a.27.27 0 0 0 .276-.263V9.78a.27.27 0 0 0-.276-.264M13.352 13.064H5.355a.27.27 0 0 0-.276.264v.89a.27.27 0 0 0 .276.265h7.997a.27.27 0 0 0 .276-.264v-.891a.27.27 0 0 0-.276-.264"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M6.106 10.489a.3.3 0 0 0 .206-.026.27.27 0 0 0 .13-.155 5.64 5.64 0 0 1 2.647-3.144 6.06 6.06 0 0 1 4.17-.614c.069.014.14.002.2-.033a.26.26 0 0 0 .12-.157l.242-.862a.25.25 0 0 0-.032-.206.27.27 0 0 0-.178-.12 7.6 7.6 0 0 0-5.273.768c-1.594.882-2.782 2.307-3.327 3.99a.25.25 0 0 0 .024.203.27.27 0 0 0 .17.125zM17.894 13.511a.3.3 0 0 0-.206.026.27.27 0 0 0-.13.155 5.64 5.64 0 0 1-2.647 3.144 6.06 6.06 0 0 1-4.17.614.28.28 0 0 0-.2.034.26.26 0 0 0-.12.156l-.242.862a.25.25 0 0 0 .032.206.27.27 0 0 0 .178.12 7.6 7.6 0 0 0 5.273-.768c1.594-.882 2.782-2.306 3.327-3.99a.25.25 0 0 0-.024-.203.27.27 0 0 0-.17-.125z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      d="M16.226 7.96c.449 0 .813-.349.813-.779s-.364-.778-.814-.778-.813.349-.813.778.364.778.813.778M7.774 17.597c.45 0 .813-.348.813-.778s-.364-.778-.813-.778-.813.348-.813.778.364.778.813.778"
    />
  </svg>
);
const ForwardRef = React.forwardRef(SegmentDark);
export { ForwardRef as SegmentDark };
